<template>
  <div>
    <b-spinner
      variant="primary"
      v-if="isSpinner"
      large
      class="pageLoadSpinners"
    />
    <div v-show="!isSpinner">
      <b-spinner
        variant="primary"
        v-if="isUpdating"
        large
        class="pageLoadSpinners"
        style="position: fixed"
      />

      <div class="card user_filter cancel_session upcoming_session">
        <h2>Filters</h2>

        <b-form @submit.prevent>
          <b-row>
            <b-col xl="3" lg="3" md="3">
              <label>Learner Name</label>
              <b-dropdown
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                :text="user_type_selected"
                variant="outline-secondary"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="item in user_type_options"
                  :key="item.value"
                  @click="user_type_selected = item.text"
                  >{{ item.text }}</b-dropdown-item
                >
              </b-dropdown>
            </b-col>
            <b-col xl="3" lg="3" md="3">
              <label>Tutor Name</label>
              <b-dropdown
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                :text="tutor_type_selected"
                variant="outline-secondary"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="item in tutor_type_options"
                  @click="tutor_type_selected = item.text"
                  :key="item.value"
                  >{{ item.text }}</b-dropdown-item
                >
              </b-dropdown>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <div class="card user_table cancel_session_table upcoming_session_table">
        <div class="custom-search d-flex justify-content-end">
          <b-form-group>
            <div class="d-flex align-items-center">
              <label class="mr-1"></label>
              <b-form-input
                v-model="searchTerm"
                placeholder="Search..."
                type="text"
                class="d-inline-block"
              />
            </div>
          </b-form-group>
        </div>
        <vue-good-table
          :columns="columns"
          :rows="filterRows"
          :rtl="direction"
          class="cursor_pointer"
          @on-cell-click="onRowClick"
          :search-options="{
            enabled: true,
            externalQuery: searchTerm,
          }"
          :select-options="{
            enabled: true,
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
          }"
          :pagination-options="{
            enabled: true,
            perPage: pageLength,
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'bookingId'" class="text-nowrap">
              <span
                class="text-nowrap"
                >{{ props.row.bookingId }}</span
              >
            </span>
            <span
              v-else-if="props.column.field === 'sessionBookingDate'"
              class="text-nowrap"
            >
              {{sessionTimeCalculate(props.row.sessionBookingDate, props.row.sessionEndDate)}}
            </span>
            <span
              v-else-if="props.column.field === 'bookingCredits'"
              class="booking_Credits"
            >
              <span v-if="props.row.bookingCredits !== 0">
              {{ props.row.bookingCredits }} Credits
              </span>
              <span v-else style="color:red">
                Trial Booking
              </span>
              
            </span>

            <span
              v-else-if="props.column.field === 'sessionTitle'"
              class="seesion_title"
            >
              {{ props.formattedRow[props.column.field] }}
            </span>
            <span
              v-else-if="props.column.field === 'tutorType'"
              class="tutor_type"
            >
              <b-badge :variant="tutorType[1][props.row.tutorType]">
                {{ tutorType[0][props.row.tutorType] }}
              </b-badge>
            </span>
            <span
              v-else-if="props.column.field === 'learnerChildName'"
              class="text-nowrap"
            >
              <b-avatar :src="props.row.avatarForLearner" class="user_img" />
              <router-link
              :to="{
                  name: 'user-details',
                  params: {
                      id: props.row.bookinglernerId
                  },
              }"
              >
                {{ props.row.learnerChildName }}
              </router-link>
            </span>
            <span
              v-else-if="props.column.field === 'tutorNameDetail'"
              class="text-nowrap"
            >
              <b-avatar :src="props.row.avatarForTutor" class="user_img" />
              <router-link
              :to="{
                  name: 'user-details',
                  params: {
                      id: props.row.bookingTutor
                  },
              }"
              >
                {{ props.row.tutorNameDetail }}
              </router-link>
            </span>
            <span v-else-if="props.column.field === 'status'" class="status">
              <b-badge :variant="status[1][props.row.status]">
                {{ status[0][props.row.status] }}
              </b-badge>
            </span>
            <span
              v-else-if="props.column.field === 'cancellationReason'"
              class="cancel_reason"
            >
              {{ props.formattedRow[props.column.field] }}
            </span>
            <span
              v-else-if="props.column.field === 'action'"
              class="action_field action_field1512"
            >
              <span>
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                  >
                  <template v-slot:button-content>
                      <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="text-body align-middle mr-25"
                      />
                  </template>
                  <b-dropdown-item>
                      <span v-b-modal.modal-cancel-booking 
                        @click="selctedData = props.row">
                          <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              >
                                  <path
                                  d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389959 7.20038 -0.17433 9.00998 0.172936 10.7558C0.520203 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0ZM9 16.3636C7.54361 16.3636 6.11993 15.9318 4.90899 15.1226C3.69804 14.3135 2.75423 13.1635 2.19689 11.8179C1.63955 10.4724 1.49373 8.99183 1.77786 7.56343C2.06199 6.13502 2.7633 4.82295 3.79313 3.79312C4.82295 2.7633 6.13502 2.06198 7.56343 1.77785C8.99183 1.49373 10.4724 1.63955 11.8179 2.19689C13.1635 2.75422 14.3135 3.69804 15.1226 4.90898C15.9318 6.11993 16.3636 7.54361 16.3636 9C16.3636 10.953 15.5878 12.8259 14.2069 14.2069C12.8259 15.5878 10.953 16.3636 9 16.3636ZM12.0355 7.12636L10.1536 9L12.0355 10.8736C12.1121 10.9497 12.173 11.0402 12.2145 11.1399C12.2561 11.2396 12.2775 11.3465 12.2775 11.4545C12.2775 11.5626 12.2561 11.6695 12.2145 11.7692C12.173 11.8689 12.1121 11.9594 12.0355 12.0355C11.9594 12.1121 11.8689 12.173 11.7692 12.2145C11.6695 12.2561 11.5626 12.2775 11.4545 12.2775C11.3465 12.2775 11.2396 12.2561 11.1399 12.2145C11.0402 12.173 10.9497 12.1121 10.8736 12.0355L9 10.1536L7.12637 12.0355C7.05031 12.1121 6.95981 12.173 6.86011 12.2145C6.76041 12.2561 6.65347 12.2775 6.54546 12.2775C6.43745 12.2775 6.33051 12.2561 6.2308 12.2145C6.1311 12.173 6.04061 12.1121 5.96455 12.0355C5.88786 11.9594 5.82699 11.8689 5.78546 11.7692C5.74392 11.6695 5.72253 11.5626 5.72253 11.4545C5.72253 11.3465 5.74392 11.2396 5.78546 11.1399C5.82699 11.0402 5.88786 10.9497 5.96455 10.8736L7.84637 9L5.96455 7.12636C5.81048 6.9723 5.72393 6.76334 5.72393 6.54545C5.72393 6.32757 5.81048 6.11861 5.96455 5.96454C6.11861 5.81048 6.32757 5.72392 6.54546 5.72392C6.76334 5.72392 6.9723 5.81048 7.12637 5.96454L9 7.84636L10.8736 5.96454C11.0277 5.81048 11.2367 5.72392 11.4545 5.72392C11.6724 5.72392 11.8814 5.81048 12.0355 5.96454C12.1895 6.11861 12.2761 6.32757 12.2761 6.54545C12.2761 6.76334 12.1895 6.9723 12.0355 7.12636Z"
                                  fill="#606060"
                                  />
                          </svg>
                          Cancel Booking
                      </span>
                  </b-dropdown-item>
              </b-dropdown>
              </span>
            </span>
          </template>
         <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
              <div class="d-flex align-items-center mb-0 mt-1">
                <span class="text-nowrap">
                  <span v-if="props.total === 0"> Showing 0 </span>
                  <span v-else> Showing {{(pageLength*(currentPage-1)+1)}} </span> 
                   to
                  <span v-if="props.total > pageLength*currentPage">{{(pageLength*currentPage)}} of {{ props.total }} entries</span>
                  <span v-else>{{props.total}} of {{ props.total }} entries</span>
                </span>

                    <div class="d-flex align-items-center mb-1 mt-0 showentry allsession">
                      <span>Show</span>
                      <b-form-select
                        v-model="pageLength"
                        :options="['10', '20', '30', '40', '50']"
                        class="mx-1"
                        @input="
                          (value) => props.perPageChanged({ currentPerPage: value })
                        "
                     />
                      <span>entries</span>
                    </div>
              </div>
              <div>
                <b-pagination
                  :value="1"
                  :total-rows="props.total"
                  :current-page="currentPage"
                  :per-page="pageLength"
                  first-number
                  last-number
                  align="right"
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mt-1 mb-0"
                  @input="
                    (value) => {
                      props.pageChanged({ currentPage: value });
                      currentPage = value
                    }
                  "
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>
    <b-modal
        id="modal-cancel-booking"
        ref="my-modal"
        title="Cancellation Reason"
        ok-title="Booking Cancel"
        data-class="addcredit_popup"
        data-value-class="addcredit_popup"
        centered
        cancel-variant="outline-secondary"
        @show="cancelbookingresetModal"
        @ok="cancelbookinghandleOk"
      >
      <validation-observer ref="formCancel">
        <b-form ref="form" @submit.stop.prevent="cancelbookinghandleSubmit">
            <b-form-group class="radioselected" label-for="usertype">
              <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Not interested in this Session"
              >
                Not interested in this Session
              </b-form-radio>
              <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Not available"
              >
                Not available
              </b-form-radio>
              <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Medical Emergency"
              >
                Medical Emergency
              </b-form-radio>
              <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Family situation"
              >
                Family situation
              </b-form-radio>
              <b-form-radio
                v-model="RadioSelected"
                name="some-radios"
                value="Other"
              >
                Other
              </b-form-radio>
            </b-form-group>
          <validation-provider
            #default="{ errors }"
            name="reason for cancellation"
            rules="required|min:3|max:300"
            v-if="RadioSelected === 'Other'"
          >
            <b-form-group
              :state="nameState"
              label-for="name-input"
              invalid-feedback="Reason for Cancellation is required"
              v-if="RadioSelected === 'Other'"
            >
            <label style="font-weight:600;">Reason for Cancellation</label>
              <b-form-textarea
                id="name-input"
                v-model="cancelReason"
                :state="nameState"
                placeholder="Enter Reason For Cancellation"
                required
              />
              <small class="text-danger" style="display:block;">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BForm,
  BSpinner,
  BCardText,
  BFormTextarea,
  BFormRadio,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import * as insertFirebase from "@/utils/FirebaseQueries/insertQueries/insertQueries.js";
import * as updateFirebase from "@/utils/FirebaseQueries/updateQueries/updateQueries.js";
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapGetters,mapActions,mapMutations } from "vuex";
import { dbCollections } from '@/utils/firebaseCollection';
import {errorEmail} from "@/utils/apiRequests.js"
const currentFileName = "@/views/SessionsManagement/UpcomingSession(s)/upcomingSessionList.vue"
import firebase from "@/utils/firebaseInit"
const db = firebase.firestore();
import { adminBookingNotification } from '../PendingSession(s)/service.js';
import { onBookingCancelUpdateSlot } from '@/utils/globalFunction/updateSlotWhenCancelBookingService.js'
import axios from "axios";
import moment from "moment";
export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    BForm,
    BButton,
    BSpinner,
    BCardText,
        BFormTextarea,
    BFormRadio,
    ValidationProvider, ValidationObserver,
  },
  data() {
    return {
      direction: false,
      isSpinner: false,
      name:'',
      selctedSessionId: '',
      isUpdating: false,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },

      user_type_selected: "All",
    
      tutor_name_selected: "All",
    
      tutor_type_selected: "All",

      status_selected: null,
      status_options: [
        { value: null, text: "All" },
        { value: "a", text: "Active" },
        { value: "b", text: "Suspend" },
        { value: "c", text: "Block" },
      ],
      Total_no_of_Warning: null,
      Total_no_of_Warning: [
        { value: 0, text: "noraml" },
        { value: 1, text: "normal" },
        { value: 2, text: "danger" },
        { value: 3, text: "normal" },
      ],

      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Booking ID",
          field: "bookingId",
        },
        {
          label: "Session Booking Date & Time",
          field: "sessionBookingDate",
        },
        {
          label: "Session(s) Title",
          field: "sessionTitle",
        },
        {
          label: "Tutor Name",
          field: "tutorNameDetail",
        },
        {
          label: "Learner Name",
          field: "learnerChildName",
        },

        {
          label: "Booking Credits",
          field: "bookingCredits",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Active",
          3: "Block",
          4: "Suspend",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
      tutorType: [
        {
          1: "Valuable",
          2: "Elite",
          3: "Normal",
          4: "N/A",
        },
        {
          1: "light-primary",
          2: "light-danger",
          3: "light-success",
          4: "light-dark",
        },
      ],
      totalNoOfWarning: [
        {
          1: "Valuable",
          2: "Elite",
          3: "Normal",
          4: "N/A",
        },
        {
          1: "light-primary",
          2: "light-danger",
          3: "light-success",
          4: "light-dark",
        },
      ],
      selectedAction:'',
      RadioSelected: "Not interested in this Session",
      rowsArray: [],
      selectedLearnerProfile:'',
      selectedLearnerLastName:'',
      selectedLearnerFirstName:'',
      selectedBookingCredit:'',
      selectedLearnerID:'',
      selctedData: null,
      cancelReason:''
    };
  },
  created() {
    this.isSpinner = true;
    let self = this;
    self.$root.$on("stopSpinnerForActionPerform", () => {
      self.isSpinner = false;
    });
    self.$root.$on('startSpinnerForActionPerform', () => {
      self.isSpinner = true;
    });
    let getUpcomingSessionFound = this.getupComingSessionList.length !== 0;
    if(!getUpcomingSessionFound){
      this.getupComingSession().then(res=>{
        this.rows()
      }).catch(error=>{
        console.error("error",error)
        this.isSpinner = false;
      })
    }else{
      this.isSpinner = false;
      this.rows()
    }
  },
  computed: {
    ...mapGetters({
      getupComingSessionList: "upComingSession/getupComingSession",
    }),
    user_type_options() {
      var learnerName = [];
      learnerName.push({ value: 0, text: "All" });
      for (var i = 0; i < this.rowsArray.length; i++) {
        var temp = false;
        for (var j = 0; j < learnerName.length; j++) {
          if (this.rowsArray[i].learnerChildName == learnerName[j].text) {
            temp = true;
          }
        }
        if (!temp) {
          var obj = {
            val: i + 1,
            text: this.rowsArray[i].learnerChildName,
          };
          learnerName.push(obj);
        }
      }
      return learnerName;
    },
    tutor_type_options() {
      var tutorName12 = [];
      tutorName12.push({ value: 0, text: "All" });
      for (var i = 0; i < this.rowsArray.length; i++) {
        var temp = false;
        for (var j = 0; j < tutorName12.length; j++) {
          if (this.rowsArray[i].tutorNameDetail == tutorName12[j].text) {
            temp = true;
          }
        }
        if (!temp) {
          var obj = {
            val: i + 1,
            text: this.rowsArray[i].tutorNameDetail,
          };
          tutorName12.push(obj);
        }
      }
      return tutorName12;
    },
    filterRows() {
      var self = this;
      var listA = this.rowsArray;
      if (
        self.user_type_selected == "All" &&
        self.tutor_type_selected == "All"
      ) {
        return listA;
      }
      if (self.user_type_selected != "All") {
        listA = listA.filter((data) => {
          return data.learnerChildName
            .toLowerCase()
            .includes(self.user_type_selected.toLowerCase());
        });
      }
      if (self.tutor_type_selected != "All") {
        listA = listA.filter((dataTutor) => {
          return dataTutor.tutorNameDetail
            .toLowerCase()
            .includes(self.tutor_type_selected.toLowerCase());
        });
      }
      return listA;
    },

  },
  methods: {
    ...mapMutations({
      'testMutation' : "upComingSession/testMutation",
      'cancelSessionTest' : "cancelSessionDetails/cancelSessionTests",
      'cancelSessionArrayEmptyForList' : "cancelSessionDetails/setCancelSessionArray"
   }),
    ...mapActions({
        'getupComingSession' : 'upComingSession/getupComingSessionData',
      }),
    onRowClick(data) {
      if (data.column.field === "action") {
        return false;
      } else if(data.column.field === "tutorNameDetail") {
        this.$router.push({ name: 'user-details', params: { id: data.row.bookingTutor}})
      }else if(data.column.field === "learnerChildName"){
        this.$router.push({ name: 'user-details', params: { id: data.row.bookinglernerId}})
      }else{    
        this.$router.push({ name: 'upcoming-session-details',params: {id: data.row.Id,}})         
      }
    },
    rows() {
      try {
        this.isSpinner = true
        let self = this;
        if(this.getupComingSessionList.length === 0){
          this.isSpinner = false
        }
        self.getupComingSessionList.forEach((items) => {
          if(items.startTime?.seconds*1000 >= new Date().getTime()){
            var object = {
              bookingId: items.bookingId,
              lernerId: items.learnerId,
              Id: items.id,
              avatarForLearner: items.learnerDetails.profileImage,
              avatarForTutor: items.tutorDetails.profilePicture,
              sessionBookingDate: items.startTime,
              sessionEndDate: items.endTime,
              sessionTitle: items.sessionDetails.name ? items.sessionDetails.name : '',
              learnerChildName:
                items.learnerDetails.firstName +
                " " +
                items.learnerDetails.lastName,
              tutorNameDetail: items.tutorDetails.firstName + " " + items.tutorDetails.lastName,
              bookingCredits: items.usedCredits?items.usedCredits:0,
              bookingTutor: items.tutor,
              bookinglernerId: items.learnerId,
              learnerFirstName: items.learnerDetails ? items.learnerDetails.firstName :'',
              learnerlastName: items.learnerDetails ? items.learnerDetails.lastName : '',
              isTrial: items.isTrial ? items.isTrial : null,
            }
            this.rowsArray.push(object);
            if(self.getupComingSessionList.length === this.rowsArray.length){
              this.isSpinner = false
            }
          };
        });  
      } catch (error) {
        console.error("error",error)
        errorEmail({
          projectName : process.env.VUE_APP_PROJECTNAME,
          environment : process.env.NODE_ENV,
          fileName : currentFileName,
          hookName : "rows",
          errorMessage : error.message
        },(mailRes) => {
          if(mailRes.error){
            console.error(mailRes);
          }
        })
      }
    },
    sessionTimeCalculate(startTime , endTime) {
      if (moment(startTime.seconds*1000).format("DD-MM-YYYY") == moment(endTime.seconds*1000).format("DD-MM-YYYY")) {
        return `${moment(startTime.seconds*1000).format("DD-MM-YYYY, hh:mm A")} to ${moment(endTime.seconds*1000).format("hh:mm A")}`
      } else {
        return `${moment(startTime.seconds*1000).format("DD-MM-YYYY, hh:mm A")} to ${moment(endTime.seconds*1000).format("DD-MM-YYYY, hh:mm A")}`
      }
    },
    TemplateCreatedDate(TemplateCreatedDate) {
      let self = this;
      var notificationDate = new Date(
        TemplateCreatedDate.seconds * 1000
      ).getDate();
      var notificationMonth =
        new Date(TemplateCreatedDate.seconds * 1000).getMonth() + 1;
      var notificationYear = new Date(
        TemplateCreatedDate.seconds * 1000
      ).getFullYear();
      var returnnotificationDate =
        self.addZero(notificationDate) +
        "-" +
        self.addZero(notificationMonth) +
        "-" +
        notificationYear +
        ", " +
        self.notificationCreateTime(
          new Date(TemplateCreatedDate.seconds * 1000)
        );
      return returnnotificationDate;
    },
    TemplateEndDate(TemplateCreatedDate) {
      let self = this;
      var returnnotificationDate = self.notificationCreateTime(
        new Date(TemplateCreatedDate.seconds * 1000)
      );
      return returnnotificationDate;
    },
    notificationCreateTime(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      hours = hours<10 ? '0'+hours:hours
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    addZero(value) {
      if (value > 9) {
        return value;
      } else {
        return "0" + value;
      }
    },
    cancelbookingresetModal() {
      this.name = "";
      this.RadioSelected = "Not interested in this Session";
      this.cancelReason = '';
      this.nameState = null;
    },
    cancelbookinghandleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.cancelbookinghandleSubmit(bvModalEvt);   
    },
    cancelbookinghandleSubmit() {
      
      try {
        this.$refs.formCancel.validate().then(async(valid)=>{
        if(valid){
          this.$bvModal.hide("modal-cancel-booking");
          this.isSpinner = true;
          let Index = this.rowsArray.findIndex((values) => {
            return values.Id == this.selctedData.Id;
          });
          let Indexs = this.getupComingSessionList.findIndex((values) => {
            return values.id == this.selctedData.Id;
          });
          try {
            if (!this.selctedData.isTrial) {   
              await db.collection(dbCollections.CREDITTRANSACTIONS).where("userId","==",this.selctedData.lernerId).orderBy("createdAt", "desc").limit(1).get().then(async(docData) => {
                
                if(docData.empty){
                  return;
                }else{
                    let sengleBookingData = docData.docs[0].data();                                         
                    const updateObj = {
                      currentCredit : Number(sengleBookingData.availableCredit) + Number(this.selctedData.bookingCredits)
                    }
                    await updateFirebase.updateRootCollectionDataByDocId(dbCollections.USERS,this.selctedData.lernerId,updateObj,async(res) => {
                      if(!res){
                        return;
                      }
                      const learnerDeatil = {
                        firstName : this.selctedData.learnerFirstName,
                        lastName :this.selctedData.learnerlastName,
                        profileImage: this.selctedData.avatarForLearner
                      }
                      const transactionObject = {
                        availableCredit:Number(sengleBookingData.availableCredit) + Number(this.selctedData.bookingCredits),
                        bookingId:this.selctedData.bookingId,
                        createdAt:new Date(),
                        credits:Number(this.selctedData.bookingCredits),
                        id:'',
                        paymentId:'',// This feild is static
                        reference:1,
                        remarks:'Booking cancelled.',
                        transactionType:"cr",
                        userDetail:learnerDeatil,
                        userId: this.selctedData.lernerId,
                        isSendNotification: false
                      }
                      insertFirebase.addDataToRootCollection(dbCollections.CREDITTRANSACTIONS,transactionObject,async(credit) => {
                        if(credit){
                          const updateObjCredit = {
                            id : credit.id
                          }
                          await updateFirebase.updateRootCollectionDataByDocId(dbCollections.CREDITTRANSACTIONS,credit.id,updateObjCredit,async(creditUpdate) => {
                              const cancelreasondetail = {
                              cancellationReason: this.RadioSelected === "Other"? this.cancelReason : this.RadioSelected,
                              status: Number(3),
                              cancelReasonStatus: Number(0),
                              cancellationDate: new Date(),
                              updatedAt: new Date(),
                              usedCredits: 0
                            };
                            updateFirebase.updateRootCollectionDataByDocId(
                              dbCollections.BOOKING,
                              this.selctedData.Id,
                              cancelreasondetail,
                              async(res) => {
                                if(!res){
                                  return;
                                }
                                let newArray = [];
                                this.cancelSessionArrayEmptyForList(newArray);
                                adminBookingNotification({
                                  bookingData : {...this.getupComingSessionList[Indexs], status:3, cancellationReason: this.RadioSelected === "Other"? this.cancelReason : this.RadioSelected}
                                }, (resp) => {});
                                onBookingCancelUpdateSlot({
                                bookingId:  this.selctedData.Id
                                },() => {})
                                this.rowsArray.splice(Index,1);
                                this.getupComingSessionList.splice(Indexs,1);
                                this.$root.$emit(
                                  "showToastMessage",
                                  "Booking cancel successfully.",
                                  "success"
                                );
                                this.isSpinner = false
                              });
                          })
                        }
                      })
                    })  
                  }
              })
              .catch((error) => {
                  console.error(error);
              })
            } else {
               const cancelreasondetail = {
                cancellationReason: this.RadioSelected === "Other"? this.cancelReason : this.RadioSelected,
                status: Number(3),
                cancelReasonStatus: Number(0),
                cancellationDate: new Date(),
                updatedAt: new Date(),
                usedCredits: 0
              };
              updateFirebase.updateRootCollectionDataByDocId(
                dbCollections.BOOKING,
                this.selctedData.Id,
                cancelreasondetail,
                async(res) => {
                  if(!res){
                    return;
                  }
                  let newArray = [];
                  this.cancelSessionArrayEmptyForList(newArray);
                  adminBookingNotification({
                    bookingData : {...this.getupComingSessionList[Indexs], status:3, cancellationReason: this.RadioSelected === "Other"? this.cancelReason : this.RadioSelected}
                  }, () => {});
                  onBookingCancelUpdateSlot({
                    bookingId:  this.selctedData.Id
                  },() => {})
                  this.rowsArray.splice(Index,1);
                  this.getupComingSessionList.splice(Indexs,1);
                  this.$root.$emit(
                    "showToastMessage",
                    "Booking cancel successfully.",
                    "success"
                  );
                  this.isSpinner = false
                });
            }
            } catch (error) {
              console.error("error", error);
              this.isUpdating = false
            }
          }
        })
      } catch (error) {
        console.error("error",error)
        errorEmail({
          projectName : process.env.VUE_APP_PROJECTNAME,
          environment : process.env.NODE_ENV,
          fileName : currentFileName,
          hookName : "cancelbookinghandleSubmit",
          errorMessage : error.message
        },(mailRes) => {
          if(mailRes.error){
            console.error(mailRes);
          }
        })
      }
    },
  },
};
</script>

